import { Injectable, Renderer2, RendererFactory2, Type } from '@angular/core';
import { MatDialog, MatDialogConfig, MatDialogRef } from '@angular/material/dialog';

@Injectable({
    providedIn: 'root',
})
export class SidePanelService {
    height: string;
    rightOffset: string;
    private dialogRef: MatDialogRef<any, any>;
    private resizeListener: () => void;
    private renderer: Renderer2;

    constructor(public dialog: MatDialog, private rendererFactory: RendererFactory2) {
        this.renderer = rendererFactory.createRenderer(null, null);
    }

    private calculateModalHeightWidth() {
        const drawerContentElement = document.querySelector('.mat-drawer-content') as HTMLElement;
        const measurement = { height: '0px', rightOffset: '0px', width: '0px' };
        if (drawerContentElement) {
            measurement.height = `${drawerContentElement.offsetHeight}px`;
            const drawerRect = drawerContentElement.getBoundingClientRect();
            measurement.rightOffset = `${window.innerWidth - drawerRect.right}px`;
            // matDialogConfig.width = drawerRect.width > 627 ? `30%` : `${window.innerWidth}px`;
            measurement.width = window.innerWidth <= 768 ? '90%' : '35%';
        }
        return measurement;
    }

    open(component: Type<any>, matDialogConfig: MatDialogConfig = {}) {
        const measurement = this.calculateModalHeightWidth();
        this.height = measurement.height;
        this.rightOffset = measurement.rightOffset;
        matDialogConfig.width = measurement.width;

        const config: MatDialogConfig = {
            ...matDialogConfig,
            height: this.height,
            position: { right: this.rightOffset, ...matDialogConfig.position },
            panelClass: 'side-panel',
        };

        this.dialogRef = this.dialog.open(component, config);

        this.addResizeListener();

        this.dialogRef.afterClosed().subscribe(() => {
            this.removeResizeListener();
            // this.dialogRef = null;
        });

        return this.dialogRef;
    }

    private addResizeListener() {
        if (!this.resizeListener) {
            this.resizeListener = this.renderer.listen('window', 'resize', () => {
                if (this.dialogRef) {
                    const measurement = this.calculateModalHeightWidth();
                    this.dialogRef.updateSize(measurement.width, measurement.height);
                }
            });
        }
    }

    private removeResizeListener() {
        if (this.resizeListener) {
            this.resizeListener();
            this.resizeListener = () => {};
        }
    }
}
